import "./WhatWeDo.scss";
import Banner from "../../Common/Banner/Banner";
import HairLine from "./HairLine";
import iconPathURL from "../../Common/iconPath";
const iconPath = process.env.PUBLIC_URL + "/assets/images/whatWeDo/";

export default function WhatWeDoContent(props) {
  const ptitle = props.paragraph_title;
  const listItemsTitle = props.whatWeDoData.map((data, i) => (
    <>
      <div
        className="text-container-section col-xs-12 col-sm-12 col-md-10 col-lg-10"
        key={i}
      >
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
            <h2 className="title-content">{data.title}</h2>
            <p>{data.description}</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            {<img src={iconPathURL(data.src)} width="100%" alt="img"></img>}
          </div>
        </div>
      </div>

      <HairLine />
    </>
  ));

  return (
    <div>
      <Banner
        imgSrc={`${iconPath}whatwedo_background.png`}
        title="What We Do"
      />

      <div className="first-p">
        <div className="text-container-section col-xs-12 col-sm-12 col-md-10 col-lg-10 row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <p className="title-p">{ptitle}</p>
          </div>
        </div>
      </div>
      <HairLine />
      {listItemsTitle}
    </div>
  );
}
